/**
 * TITAN Vehicle Selector v2
 * Grouped model display with optgroup headers
 */

(function() {
  'use strict';

  var STORAGE_KEY = 'titan_selected_vehicle';
  var DATA_URL = 'https://cdn.shopify.com/s/files/1/0732/6361/2210/files/makemodeldata30.json?v=1792428048';

  function initVehicleSelectors() {
    var containers = document.querySelectorAll('[data-titan-vehicle-selector]');
    for (var i = 0; i < containers.length; i++) {
      new TitanVehicleSelector(containers[i]);
    }
  }

  function TitanVehicleSelector(container) {
    this.container = container;
    this.data = null;
    this.selection = { make: null, model: null, modelName: null };
    this.init();
  }

  TitanVehicleSelector.prototype.init = function() {
    var self = this;
    this.renderForm();
    this.loadData().then(function() {
      self.populateMakes();
      self.restoreSelection();
    });
  };

  TitanVehicleSelector.prototype.loadData = function() {
    var self = this;
    return fetch(DATA_URL)
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function(json) {
        self.data = json;
      })
      .catch(function(err) {
        console.error('TitanVehicleSelector: Failed to load data', err);
        self.showError();
      });
  };

  TitanVehicleSelector.prototype.renderForm = function() {
    this.container.innerHTML = ''
      + '<div class="titan-vs-wrapper">'
      + '  <div class="titan-vs-header">'
      + '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0;">'
      + '      <rect x="1" y="3" width="15" height="13" rx="2"/>'
      + '      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>'
      + '      <circle cx="5.5" cy="18.5" r="2.5"/>'
      + '      <circle cx="18.5" cy="18.5" r="2.5"/>'
      + '    </svg>'
      + '    <div>'
      + '      <div style="font-weight:700;font-size:1rem;color:var(--titan-text);">Find Your Van</div>'
      + '      <div style="font-size:0.8125rem;color:var(--titan-text-muted);">Select your vehicle for compatible products</div>'
      + '    </div>'
      + '  </div>'
      + '  <div class="titan-vs-fields">'
      + '    <div class="titan-vs-field">'
      + '      <label class="titan-vs-label" for="titan-make-' + this.container.id + '">Manufacturer</label>'
      + '      <select class="titan-vs-select" id="titan-make-' + this.container.id + '">'
      + '        <option value="">Loading makes...</option>'
      + '      </select>'
      + '    </div>'
      + '    <div class="titan-vs-field">'
      + '      <label class="titan-vs-label" for="titan-model-' + this.container.id + '">Model</label>'
      + '      <select class="titan-vs-select" id="titan-model-' + this.container.id + '" disabled>'
      + '        <option value="">Select manufacturer first</option>'
      + '      </select>'
      + '    </div>'
      + '    <button class="titan-btn titan-btn-primary titan-btn-full" id="titan-search-' + this.container.id + '" disabled style="margin-top:8px;">'
      + '      Show Compatible Products'
      + '    </button>'
      + '  </div>'
      + '  <div id="titan-vs-saved-' + this.container.id + '" style="display:none;"></div>'
      + '  <button class="titan-vs-reset" id="titan-reset-' + this.container.id + '" style="display:none;margin-top:12px;background:none;border:none;color:var(--titan-text-muted);font-size:0.8125rem;cursor:pointer;text-decoration:underline;">'
      + '    Change vehicle'
      + '  </button>'
      + '</div>';

    this.bindEvents();
  };

  TitanVehicleSelector.prototype.populateMakes = function() {
    if (!this.data) return;
    var makeSelect = this.container.querySelector('[id^="titan-make-"]');
    if (!makeSelect) return;

    var html = '<option value="">Select manufacturer...</option>';
    for (var i = 0; i < this.data.length; i++) {
      html += '<option value="' + i + '">' + this.data[i].name + '</option>';
    }
    makeSelect.innerHTML = html;
  };

  TitanVehicleSelector.prototype.bindEvents = function() {
    var self = this;
    var makeSelect = this.container.querySelector('[id^="titan-make-"]');
    var modelSelect = this.container.querySelector('[id^="titan-model-"]');
    var searchBtn = this.container.querySelector('[id^="titan-search-"]');
    var resetBtn = this.container.querySelector('[id^="titan-reset-"]');

    if (makeSelect) {
      makeSelect.addEventListener('change', function() {
        self.onMakeChange(this.value);
      });
    }
    if (modelSelect) {
      modelSelect.addEventListener('change', function() {
        self.onModelChange(this.value, this.options[this.selectedIndex].text);
      });
    }
    if (searchBtn) {
      searchBtn.addEventListener('click', function() {
        self.onSearch();
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        self.onReset();
      });
    }
  };

  TitanVehicleSelector.prototype.onMakeChange = function(makeIndex) {
    var modelSelect = this.container.querySelector('[id^="titan-model-"]');
    var searchBtn = this.container.querySelector('[id^="titan-search-"]');

    if (makeIndex === '' || makeIndex === null || makeIndex === undefined) {
      modelSelect.innerHTML = '<option value="">Select manufacturer first</option>';
      modelSelect.disabled = true;
      searchBtn.disabled = true;
      return;
    }

    var makeData = this.data[parseInt(makeIndex)];
    if (!makeData || !makeData.models) return;

    this.selection.make = makeData.name;

    // Build grouped options
    var html = '<option value="">Select model...</option>';
    for (var i = 0; i < makeData.models.length; i++) {
      var group = makeData.models[i];
      html += '<optgroup label="' + group.group + '">';
      for (var j = 0; j < group.variants.length; j++) {
        var variant = group.variants[j];
        html += '<option value="' + variant.handle + '">' + variant.name + '</option>';
      }
      html += '</optgroup>';
    }
    modelSelect.innerHTML = html;
    modelSelect.disabled = false;
    searchBtn.disabled = true;
  };

  TitanVehicleSelector.prototype.onModelChange = function(handle, name) {
    var searchBtn = this.container.querySelector('[id^="titan-search-"]');
    if (!handle) {
      searchBtn.disabled = true;
      return;
    }
    this.selection.model = handle;
    this.selection.modelName = name;
    searchBtn.disabled = false;
  };

  TitanVehicleSelector.prototype.onSearch = function() {
    if (!this.selection.model) return;
    this.saveSelection();
    window.location.href = '/collections/' + this.selection.model;
  };

  TitanVehicleSelector.prototype.onReset = function() {
    this.selection = { make: null, model: null, modelName: null };
    sessionStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);

    var fields = this.container.querySelector('.titan-vs-fields');
    var saved = this.container.querySelector('[id^="titan-vs-saved-"]');
    var resetBtn = this.container.querySelector('[id^="titan-reset-"]');
    if (fields) fields.style.display = '';
    if (saved) saved.style.display = 'none';
    if (resetBtn) resetBtn.style.display = 'none';

    var makeSelect = this.container.querySelector('[id^="titan-make-"]');
    var modelSelect = this.container.querySelector('[id^="titan-model-"]');
    var searchBtn = this.container.querySelector('[id^="titan-search-"]');
    if (makeSelect) makeSelect.selectedIndex = 0;
    if (modelSelect) { modelSelect.innerHTML = '<option value="">Select manufacturer first</option>'; modelSelect.disabled = true; }
    if (searchBtn) searchBtn.disabled = true;
  };

  TitanVehicleSelector.prototype.saveSelection = function() {
    var data = {
      make: this.selection.make,
      model: this.selection.model,
      modelName: this.selection.modelName,
      timestamp: Date.now()
    };
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch(e) {}
  };

  TitanVehicleSelector.prototype.restoreSelection = function() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY) || localStorage.getItem(STORAGE_KEY);
      if (!stored) return;
      var data = JSON.parse(stored);
      if (Date.now() - data.timestamp > 7 * 24 * 60 * 60 * 1000) return;
      this.showSavedState(data);
    } catch(e) {}
  };

  TitanVehicleSelector.prototype.showSavedState = function(data) {
    var fields = this.container.querySelector('.titan-vs-fields');
    var saved = this.container.querySelector('[id^="titan-vs-saved-"]');
    var resetBtn = this.container.querySelector('[id^="titan-reset-"]');

    if (fields) fields.style.display = 'none';
    if (resetBtn) resetBtn.style.display = 'inline-block';
    if (saved) {
      saved.style.display = 'block';
      saved.innerHTML = ''
        + '<div style="display:flex;align-items:center;gap:12px;padding:16px;background:rgba(255,206,0,0.1);border:1.5px solid var(--titan-green);border-radius:12px;">'
        + '  <div style="width:36px;height:36px;background:var(--titan-green);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;">'
        + '    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--titan-accent-text,#1a1a1a)" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>'
        + '  </div>'
        + '  <div>'
        + '    <div style="font-size:0.75rem;font-weight:600;color:#aaa;">Your selected vehicle</div>'
        + '    <div style="font-size:1rem;font-weight:700;color:#fff;">' + data.make + ' ' + (data.modelName || '') + '</div>'
        + '  </div>'
        + '</div>'
        + '<a href="/collections/' + data.model + '" class="titan-btn titan-btn-primary titan-btn-full" style="margin-top:12px;">View Compatible Products</a>';
    }
  };

  TitanVehicleSelector.prototype.showError = function() {
    var fields = this.container.querySelector('.titan-vs-fields');
    if (fields) {
      fields.innerHTML = '<p style="color:var(--titan-text-muted);font-size:0.875rem;text-align:center;padding:16px;">Unable to load vehicle data. <a href="/pages/search-by-make-model" style="color:var(--titan-text);text-decoration:underline;">Try the full selector</a></p>';
    }
  };

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVehicleSelectors);
  } else {
    initVehicleSelectors();
  }

  window.TitanVehicleSelector = TitanVehicleSelector;

})();
